import React, { useState } from 'react';

import LogoutModal from './LogoutModal';
import DeleteAccountModal from './DeleteAccountModal';
import PasswordSection from 'components/pages/settings/PasswordSection';
import UserFullName from 'components/common/userfullname/UserFullName';
import Modal from '@core/components/Modal/Modal';
import Spinner from '@core/components/spinner/Spinner';
import ProfileInfo from 'components/pages/settings/profileinfo/ProfileInfo';
import ContactForm from 'components/pages/settings/contactform/ContactForm';
import InterestsForm from './interestsform/InterestsForm';

import UseModal from 'hooks/use-modal';
import useWindowSize from 'hooks/use-windowSize';
import UseToast from 'hooks/use-toast';

import { useQuery } from 'react-query';
import { userProfileNewService } from 'services/auth';
import { countries } from 'country-flags-svg';

import { isUserLoggedIn, getAccessToken } from 'utils/authentication';

import { MOBILE_SLIDE_UP, MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';

import LogoutIcon from 'assets/icons/logout-icon.svg';
import AccountIcon from 'assets/icons/red-account-icon.svg';
import PasswordIcon from 'assets/icons/change-password-icon.svg';
import EditNameIcon from 'assets/icons/name-edit-icon.svg';
import { Edit2 } from 'iconsax-react';

import CareerBanner from 'components/pages/settings/account/CareerBanner/CareerBanner';
import classes from './MyAccount.module.scss';

const MyAccount = () => {
	const { toast, ToastContainer } = UseToast();
	const { mobileDevice } = useWindowSize();
	const [activeTab, setActiveTab] = useState('myAccount');
	const { data, refetch } = useQuery(
		['user-profile-new', isUserLoggedIn(), getAccessToken()],
		userProfileNewService
	);

	const {
		showModal: showLogoutModal,
		destroyModal: destroyLogoutModal,
		show: showLogout
	} = UseModal();
	const {
		showModal: showDeleteAccountModal,
		destroyModal: destoryDeleteAccountModal,
		show: showDeleteAccount
	} = UseModal();
	const {
		showModal: showChangePasswordHandler,
		destroyModal: destoryChangePassword,
		show: showChangePasswordModal
	} = UseModal();
	const {
		showModal: showFullNameHandler,
		destroyModal: destoryFullName,
		show: showFullNameModal
	} = UseModal();
	const {
		showModal: showContactModal,
		destroyModal: destoryContactModal,
		show: showContact
	} = UseModal();
	const {
		showModal: showInterestsModal,
		destroyModal: destoryInterestsModal,
		show: showInterests
	} = UseModal();

	const showDeleteSection = () => {
		if (mobileDevice) {
			showDeleteAccountModal();
		} else {
			setActiveTab('delete-account');
		}
	};

	const hideDeleteSection = () => {
		if (mobileDevice) {
			destoryDeleteAccountModal();
		} else {
			setActiveTab('myAccount');
		}
	};


	return (
		<>
			{data ? (
				<>
					{activeTab == 'myAccount' ? (
						<div className={`${classes['my-account-wrapper']}`}>
							<div className={classes['account-actions']}>								
								<ProfileInfo data={data} refetch={refetch} type="myAccount" toast={toast} />

								<ul className={`d-flex flex-column ${classes['user-info-section']}`}>
									<li className='d-flex justify-content-between align-items-center'>
										<div className="d-flex flex-column flex-md-row align-items-md-center">
											<p className="mb-2 mb-md-0">Country of Residence: </p>
											<span>
												{countries.find((crty) => crty.iso2 === data?.data.residential_country_iso)?.name || '-'}
											</span>
										</div>
										{data.data.is_verified && (
											<Edit2 role="button" onClick={() => showContactModal()} size={16} color='#666664' variant='TwoTone' />
										)}
									</li>									
									<li className="d-flex flex-column flex-md-row align-items-md-center">
										<p className="mb-2 mb-md-0">LinkedIn Profile: </p>
										<span>{data?.data.linkedin_url ? data?.data.linkedin_url : '-'}</span>
									</li>
									<li className="d-flex flex-column">
										<div className='d-flex justify-content-between align-items-start'>
											<div>
												<p className="mb-2 mb-md-0">Areas of Interest</p>
												<div className={classes['interests-wrapper']}>
													{Array.isArray(data?.data.interests) && data.data.interests.length > 0
														? data.data.interests.map((interest, idx) => (
															<div key={idx}>{interest}</div>
														))
														: '-'}
												</div>
											</div>
											{data.data.is_verified && (
												<Edit2 role="button" onClick={() => showInterestsModal()} size={16} color='#666664' variant='TwoTone' />
											)}
										</div>

										<span></span>
									</li>
									<li>
										<CareerBanner />
									</li>
								</ul>

								

								{!data?.data.is_oauth && (
									<button onClick={showChangePasswordHandler} className={classes['action']}>
										<PasswordIcon />
										<span>Change Password</span>
									</button>
								)}
								{/* <button onClick={showLogoutModal} className={classes['action']}>
									<LogoutIcon />
									<span>Log out</span>
								</button> */}
								<button onClick={showDeleteSection} className={classes['action']}>
									<AccountIcon />
									<span>Delete account</span>
								</button>
							</div>
						</div>
					) : (
						<DeleteAccountModal closeModal={hideDeleteSection} />
					)}
					<Modal show={showFullNameModal} closeHandler={destoryFullName} type={MOBILE_SLIDE_UP}>
						<UserFullName
							title="Add Your Name"
							description="Please note that your name is not editable later"
							callback={() => {
								refetch();
								destoryFullName();
							}}
						/>
					</Modal>
					<Modal
						title="Delete Account"
						show={showDeleteAccount}
						type={MOBILE_FULLSCREEN}
						closeHandler={destoryDeleteAccountModal}>
						<DeleteAccountModal closeModal={destoryDeleteAccountModal} />
					</Modal>
					<Modal header={false} show={showLogout} closeHandler={destroyLogoutModal}>
						<LogoutModal closeModal={destroyLogoutModal} />
					</Modal>
					<Modal
						title="Change Password"
						show={showChangePasswordModal}
						closeHandler={destoryChangePassword}
						type={MOBILE_SLIDE_UP}>
						<PasswordSection callback={destoryChangePassword} />
					</Modal>
					<Modal
						show={showContact}
						closeHandler={destoryContactModal}
						type={MOBILE_SLIDE_UP}>
						<ContactForm closeHandler={destoryContactModal} refetchHandler={refetch} toast={toast} />
					</Modal>
					<Modal
						show={showInterests}
						closeHandler={destoryInterestsModal}
						type={MOBILE_SLIDE_UP}>
						<InterestsForm closeHandler={destoryInterestsModal} refetchHandler={refetch} toast={toast} />
					</Modal>
				</>
			) : (
				<div className="d-flex align-items-center justify-content-center w-100 py-5">
					<Spinner />
				</div>
			)}
			<ToastContainer />
		</>
	);
};

export default MyAccount;
